import { faCreditCard } from "@fortawesome/free-solid-svg-icons";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import React from "react";
import { withRouter } from "react-router-dom";
import ReactTable from "react-table";
import { Button, Col, Container, Row } from "reactstrap";
import BaseNumericInput from "../../../toolkit/baseNumericInput";
import ModalFrame from "../../../toolkit/modalFrame";
import { userHasPermission } from "../../../utils/accessTree";
import { handleRequestError } from "../../../utils/helpers";
import {
  errorNotification,
  infoNotification
} from "../../../utils/notifications";
import permissionCodes from "../../../utils/permissionCodes";
import { getClubsRequestBe } from "../../actions/catalogs";
import { getAfiliaciones } from "../../actions/clubs";
import SideActionButton from "../common/sideActionButton";
import {
  AFILIACION,
  Props,
  State,
  TIPO_AFILIACION,
  TIPO_SERVICIO_AFILIACION
} from "./interfaces";
import s from "./styles.scss";

function getNewAfiliacion(
  clubId: number,
  tipoAfiliacion: TIPO_AFILIACION,
  tipoServicio: TIPO_SERVICIO_AFILIACION
): AFILIACION {
  return {
    idClub: clubId,
    idAfiliacion: null,
    afiliacion: "",
    tipoAfiliacion: tipoAfiliacion,
    servicio: tipoServicio,
    idSucursal: null,
    idBuzon: null
  };
}

class ClubAfiliacionesConfig extends React.Component<Props, State> {
  state = {
    onSearch: false,
    clubs: [],
    selectedClubId: null,
    selectedClubkey: null,
    selectedClubName: null,
    selectedClubAfCatOrigVisaMc: null,
    selectedClubAfCatAltVisaMc: null,
    selectedClubAfCatOrigAmex: null,
    selectedClubAfCdOrigVisaMc: null,
    selectedClubAfCdOrigAmex: null,
    modalAfiliacionesIsOpen: false
  };

  componentDidMount() {
    this.getClubsCatalog();
  }

  getClubsCatalog = () => {
    getClubsRequestBe()
      .then(({ data }) => {
        this.setState({ clubs: (data || []).filter(c => !!c.migradoCrm2) });
      })
      .catch(handleRequestError);
  };

  getAfiliacionFromList = (
    afiliaciones: AFILIACION[],
    tipoAfiliacion: TIPO_AFILIACION,
    tipoServicio: TIPO_SERVICIO_AFILIACION
  ) => {
    const tmp = afiliaciones.find(
      x => x.tipoAfiliacion == tipoAfiliacion && x.servicio == tipoServicio
    );
    if (tmp == null) {
      return getNewAfiliacion(
        this.state.selectedClubId,
        tipoAfiliacion,
        tipoServicio
      );
    }
    return tmp;
  };

  clearSelectedClub = () => {
    this.setState({
      selectedClubId: null,
      selectedClubkey: null,
      selectedClubName: null,
      selectedClubAfCatOrigVisaMc: null,
      selectedClubAfCatAltVisaMc: null,
      selectedClubAfCatOrigAmex: null,
      selectedClubAfCdOrigVisaMc: null,
      selectedClubAfCdOrigAmex: null,
      modalAfiliacionesIsOpen: false
    });
  };

  columns = [
    {
      Header: () => <p className="font-weight-bold">Clave</p>,
      Cell: row => {
        return <p>{row.original.claveCorta}</p>;
      },
      width: 200
    },
    {
      Header: () => <p className="font-weight-bold">Club</p>,
      Cell: row => {
        return <p>{row.original.nombre}</p>;
      },
      width: 400
    },
    {
      Header: () => <p className="font-weight-bold">Afiliaciones</p>,
      Cell: row => (
        <div style={{ fontSize: "1.2em" }}>
          {userHasPermission(
            permissionCodes.REPORT_CLUBS_CONFIG_AFILIACIONES_CLUB
          ) && (
            <SideActionButton
              buttonId={`afiliaciones_${row.original.clubId}`}
              tooltipTitle="Afiliaciones"
              icon={faCreditCard}
              color={"#0059b3"}
              onClick={async () => {
                getAfiliaciones(row.original.clubId)
                  .then(({ data }) => {
                    const afiliaciones = [...(data || [])];
                    const clubId = row.original.clubId;
                    const clubClave = row.original.claveCorta;
                    const clubNombre = row.original.nombre;

                    this.setState({
                      modalAfiliacionesIsOpen: true,
                      selectedClubId: clubId,
                      selectedClubkey: clubClave,
                      selectedClubName: clubNombre,
                      selectedClubAfCatOrigVisaMc: this.getAfiliacionFromList(
                        afiliaciones,
                        TIPO_AFILIACION.ORIGINAL,
                        TIPO_SERVICIO_AFILIACION.CARGO_AUTOMATICO_TDC
                      ),
                      selectedClubAfCatAltVisaMc: this.getAfiliacionFromList(
                        afiliaciones,
                        TIPO_AFILIACION.ALTERNA,
                        TIPO_SERVICIO_AFILIACION.CARGO_AUTOMATICO_TDC
                      ),
                      selectedClubAfCatOrigAmex: this.getAfiliacionFromList(
                        afiliaciones,
                        TIPO_AFILIACION.ORIGINAL,
                        TIPO_SERVICIO_AFILIACION.CARGO_AUTOMATICO_AMEX
                      ),
                      selectedClubAfCdOrigVisaMc: this.getAfiliacionFromList(
                        afiliaciones,
                        TIPO_AFILIACION.ORIGINAL,
                        TIPO_SERVICIO_AFILIACION.CARGO_DIRECTO_TDC
                      ),
                      selectedClubAfCdOrigAmex: this.getAfiliacionFromList(
                        afiliaciones,
                        TIPO_AFILIACION.ORIGINAL,
                        TIPO_SERVICIO_AFILIACION.CARGO_DIRECTO_AMEX
                      )
                    });

                    console.info(this.state);
                  })
                  .catch(e =>
                    errorNotification(
                      "No se pudieron consultar las afiliaciones actuales"
                    )
                  );
              }}
              success={null}
              confirmModal={null}
            />
          )}
        </div>
      ),
      width: 150
    }
  ];

  render() {
    const { clubs } = this.state;

    return (
      <Container className="p-0">
        <ReactTable
          data={clubs || []}
          columns={this.columns}
          className="mt-2 -striped -highlight"
          sortable={false}
          resizable={false}
          pageSize={(clubs || []).length + 1}
          showPagination={false}
        />

        <ModalFrame
          title={`Club: ${this.state.selectedClubkey} - ${this.state.selectedClubName}`}
          size={"lg"}
          isOpen={this.state.modalAfiliacionesIsOpen}
          toggle={() => {
            this.clearSelectedClub();
          }}
        >
          <Container>
            <Row className="mt-4">
              <Col xs={4}>
                <BaseNumericInput
                  label={"CAT VISA/MC"}
                  name="catVisaMcOriginal"
                  id="catVisaMcOriginal"
                  type="text"
                  value={
                    (this.state.selectedClubAfCatOrigVisaMc || {}).afiliacion
                  }
                  placeholder={""}
                  onChange={e => {
                    const { selectedClubAfCatOrigVisaMc } = this.state;
                    selectedClubAfCatOrigVisaMc.afiliacion = e.target.value;
                    this.setState({ selectedClubAfCatOrigVisaMc });
                  }}
                />
              </Col>
              <Col xs={4}>
                <BaseNumericInput
                  label={"CAT VISA/MC ALTERNA"}
                  name="catVisaMcAlterna"
                  id="catVisaMcAlterna"
                  type="text"
                  value={
                    (this.state.selectedClubAfCatAltVisaMc || {}).afiliacion
                  }
                  placeholder={""}
                  onChange={e => {
                    const { selectedClubAfCatAltVisaMc } = this.state;
                    selectedClubAfCatAltVisaMc.afiliacion = e.target.value;
                    this.setState({ selectedClubAfCatAltVisaMc });
                  }}
                />
              </Col>
              <Col xs={4}>
                <BaseNumericInput
                  label={"CAT AMEX"}
                  name="catAmexOriginal"
                  id="catAmexOriginal"
                  type="text"
                  value={
                    (this.state.selectedClubAfCatOrigAmex || {}).afiliacion
                  }
                  placeholder={""}
                  onChange={e => {
                    const { selectedClubAfCatOrigAmex } = this.state;
                    selectedClubAfCatOrigAmex.afiliacion = e.target.value;
                    this.setState({ selectedClubAfCatOrigAmex });
                  }}
                />
              </Col>
            </Row>

            <Row className="mt-4">
              <Col xs={4}>
                <BaseNumericInput
                  label={"Cargo Directo VISA/MC"}
                  name="cdirVisaMcOriginal"
                  id="cdirVisaMcOriginal"
                  type="text"
                  value={
                    (this.state.selectedClubAfCdOrigVisaMc || {}).afiliacion
                  }
                  placeholder={""}
                  onChange={e => {
                    const { selectedClubAfCdOrigVisaMc } = this.state;
                    selectedClubAfCdOrigVisaMc.afiliacion = e.target.value;
                    this.setState({ selectedClubAfCdOrigVisaMc });
                  }}
                />
              </Col>

              <Col xs={4}>
                <BaseNumericInput
                  label={"Cargo Directo AMEX"}
                  name="cdirAmexOriginal"
                  id="cdirAmexOriginal"
                  type="text"
                  value={(this.state.selectedClubAfCdOrigAmex || {}).afiliacion}
                  placeholder={""}
                  onChange={e => {
                    const { selectedClubAfCdOrigAmex } = this.state;
                    selectedClubAfCdOrigAmex.afiliacion = e.target.value;
                    this.setState({ selectedClubAfCdOrigAmex });
                  }}
                />
              </Col>
            </Row>

            <div className="mt-4">
              <Button
                className={`${s.buttonMarginTop} ${s.primaryButton}`}
                onClick={e => {
                  infoNotification("Guardando afiliaciones...");
                  this.clearSelectedClub();
                }}
                size="lg"
                block
              >
                Guardar
              </Button>
            </div>
          </Container>
        </ModalFrame>
      </Container>
    );
  }
}

export default withRouter(withStyles(s)(ClubAfiliacionesConfig));
